import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {Tooltip } from '@mui/material';
import { MOVEELEMENT } from "../../utils/commonConstant";

const SortableElement = ({ id, index, children, setSelectedElementId, dragHandle ,moveElement ,element ,totalElements,isInsideHorizontalContainer}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
    position: "relative", // Ensures the handle stays inside the draggable area
  };

  const handleClick = (event) => {
    event.stopPropagation(); // Prevent the click event from propagating to parent elements
    setSelectedElementId(id);
  }

  return dragHandle === false ?  (
    <div ref={setNodeRef} style={style}>
      <div>{children}</div>
    </div>
  ) :
  (
    <div ref={setNodeRef} style={style}>
      {/* Drag handle */}
      <div
        {...attributes}
        {...listeners}
        style={{
          position: "absolute",
          top: "10%",
          left: "0%",
          transform: "translateX(-50%)",
          width: "20px",
          height: "100px",
          cursor: "grab",
          display: "block",
        }}
      >
        {" "}⣿
      </div>
         {/* Render the children (actual content of the element) */}
          {/* Content and Move Controls Up and Down icons*/}
          {!isInsideHorizontalContainer && (
         <div onClick={handleClick} style={{ display: 'flex', alignItems: 'center' }}>
          { index > 0 &&(
         <Tooltip title="Move Up">
         <ArrowUpwardIcon 
          fontSize="small" 
          onClick={(e) => { moveElement(id, MOVEELEMENT.UP)}} 
          style={{ cursor: 'pointer',}} 
        />
          </Tooltip>
          )}
         
          {index < totalElements - 1 && (
             <Tooltip title="Move Down">
        <ArrowDownwardIcon 
          fontSize="small" 
          onClick={(e) => { moveElement(id, MOVEELEMENT.DOWN)}} 
          style={{ cursor: 'pointer', }} 
        />
        </Tooltip>
      )}
        </div>
          )}
      <div onClick={handleClick}>{children}</div>
    </div>
  )
};

export default SortableElement;
